import React from 'react';

export default function LoadingScreen() {
  return (
    <div className="global-loader">
      <div className="loader-content">
        <img src="/assets/images/logo.png" alt="VetCare Logo" className="loader-logo" />
      </div>
    </div>
  );
}
